module.exports = __webpack_public_path__ + "img/phone.cce841cc.png";